// opportunityAnalytics.js — BL-048 (ADR-068) FE Product Events (PostHog via
// the existing track() wrapper). ALLOW-LISTED, PII-safe fields only —
// identifiers/counts, NEVER address / coordinates / financials / fingerprints.

import { track } from './analytics';

export function opportunityDisplayedWithAnalysis({ opportunity_id } = {}) {
  track('opportunity_displayed_with_analysis', { opportunity_id: opportunity_id || null });
}

export function opportunityShownOnDashboard({ count } = {}) {
  track('opportunity_shown_on_dashboard', { count: Number(count) || 0 });
}

export function opportunityOpened({ opportunity_id, analysis_id } = {}) {
  track('opportunity_opened', {
    opportunity_id: opportunity_id || null,
    analysis_id: analysis_id || null,
  });
}
